export default __webpack_public_path__ + "static/media/investors_logo13.15aa2eaa.png";